import {NICEAgentState} from './NICE_AgentState';
import {NICEAgent} from './NICE_Agent.model';
import {NICEUser} from './NICE_User.model';
import {DateTime} from 'luxon';

export class AACUser
{
    cxOneAgent: NICEAgent;
    cxOneUser: NICEUser;

    /* Skybox License Data */
    aacRegisteredUserId: number;
    aacBusinessUnitId: number;
    aacBusinessUnit: string;
    aacBusinessUnitName: string;
    aacBusinessUnitType: string;
    aacBusinessUnitDomain: string;
    aacBusinessUnitApprovalRequired = true;
    aacClusterName: string;
    aacServiceLevel: string;
    aacBillingId: string;
    aacBusinessUnitMaxActiveUsers: number;
    aacBusinessUnitIsActive: boolean;
    aacBusinessUnitActivationDate: string;
    aacBusinessUnitRegistrationDate: string;
    aacBusinessUnitTrialDays: number;
    aacBusinessUnitTrialDaysRemaining: number;
    aacUserId: number;
    aacUserIsActive: boolean;
    aacUserActivationDate: string;
    aacUserLastAccessDate: string;
    aacUserConfigurations: any;
    aacBusinessUnitConfigurations: any;
    aacUserLinks: any;
    aacUserIsApproved = false;
    aacUserIsVerified = false;
    aacEmailAddress: string;
    aacUserName: string;
    aacLastName: string;
    aacAgentId: number;
    aacFirstName: string;
    aacUserImageLink = '';
    // eslint-disable-next-line @typescript-eslint/naming-convention
    categoryMap = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 1, H: 2, I: 3, J: 4, K: 5, L: 6, M: 1, N: 2, O: 3, P: 4, Q: 5, R: 6, S: 1, T: 2, U: 3, V: 4, W: 5, X: 6, Y: 1, Z: 2 };
    name: string;
    currentAgentState: NICEAgentState;
    isSkyboxUser = 'N';
    isSkyboxAdmin = 'N';

    constructor(aacUserData?: any,niceAgentData?: NICEAgent)
    {
        if (aacUserData && aacUserData.success && (aacUserData.registeredUser?.id || aacUserData.registeredUser?.isSkyboxUser === 'Y')){
            this.aacRegisteredUserId = aacUserData.registeredUser.id;
            this.aacBusinessUnitId = aacUserData.registeredUser.businessUnitId;
            this.aacBusinessUnit = aacUserData.registeredUser.businessUnit;
            this.aacBusinessUnitName = aacUserData.registeredUser.businessUnitName;
            this.aacBusinessUnitType = aacUserData.registeredUser.businessUnitType;
            this.aacBusinessUnitDomain = aacUserData.registeredUser.businessUnitDomain;
            this.aacClusterName = aacUserData.registeredUser.clusterName;
            this.aacServiceLevel = aacUserData.registeredUser.serviceLevel;
            this.aacBusinessUnitIsActive = aacUserData.registeredUser.businessUnitIsActive;
            this.aacBusinessUnitActivationDate = aacUserData.registeredUser.businessUnitActivationDate;
            this.aacBusinessUnitRegistrationDate = aacUserData.registeredUser.businessUnitRegistrationDate;
            this.aacBusinessUnitTrialDays = aacUserData.registeredUser.businessUnitTrialDays;
            this.aacBusinessUnitTrialDaysRemaining = aacUserData.registeredUser.businessUnitTrialDaysRemaining;
            this.aacUserId = aacUserData.registeredUser.userId;
            this.aacAgentId = aacUserData.registeredUser.agentId;
            this.aacFirstName = aacUserData.registeredUser.agentFirstName;
            this.aacLastName = aacUserData.registeredUser.agentLastName;
            this.aacUserName = aacUserData.registeredUser.username;
            this.aacEmailAddress = aacUserData.registeredUser.email;
            this.aacUserIsActive = aacUserData.registeredUser.userIsActive && aacUserData.registeredUser.userIsActive === 'Y';
            this.aacUserIsApproved = aacUserData.registeredUser.isApproved && aacUserData.registeredUser.isApproved === 'Y';
            this.aacUserIsVerified = aacUserData.registeredUser.isVerified && aacUserData.registeredUser.isVerified === 'Y';
            this.aacBusinessUnitApprovalRequired = aacUserData.registeredUser.businessUnitApprovalRequired && aacUserData.registeredUser.businessUnitApprovalRequired === 'Y';
            this.aacUserActivationDate = aacUserData.registeredUser.userActivationDate;
            this.aacUserLastAccessDate =  aacUserData.registeredUser.lastAccessDate;
            this.aacBusinessUnitConfigurations = aacUserData.businessUnitConfigurations;
            this.aacUserConfigurations = aacUserData.userConfigurations;
            this.aacUserLinks = aacUserData.userLinks;
            this.isSkyboxUser = aacUserData.registeredUser.isSkyboxUser;
            this.aacBillingId = aacUserData.registeredUser.businessUnitBillingId;
            this.aacBusinessUnitMaxActiveUsers = aacUserData.registeredUser.maxActiveUsers;
            this.isSkyboxAdmin = aacUserData.registeredUser.isSkyboxAdmin;
        }
        else
        {
            this.aacAgentId = 0;
            this.aacFirstName = '';
            this.aacLastName = '';
            this.aacUserName = '';
            this.aacEmailAddress = '';
        }
        if (niceAgentData && niceAgentData.agentId){
            this.cxOneAgent = new NICEAgent(niceAgentData);
        }
    }

    getLastAccessDate(): string {
        let date = '';
        if (this.aacUserLastAccessDate){
            const accessDate = this.aacUserLastAccessDate.substr(0, this.aacUserLastAccessDate.lastIndexOf(':'));
            const lastLoginUTC = DateTime.fromISO(accessDate);
            date = DateTime.fromObject(lastLoginUTC, {zone: 'utc'}).toFormat('MM/DD/YYYY hh:mm a');
        }
        return date;
    }

    getUserInitials(): string {
        let initials = '';

        if (this.cxOneAgent){
            initials = this.cxOneAgent.firstName.slice(0, 1).toUpperCase();
        }
        if (this.cxOneAgent){
            initials += this.cxOneAgent.lastName.slice(0, 1).toUpperCase();
        }
        return initials;
    }

    getUserColor(): string {
        let color = '#039be5';
        let mapCount = 0;

        if (this.cxOneAgent){
            mapCount += this.categoryMap[this.cxOneAgent.lastName.slice(0, 1).toUpperCase()];
        }
        if (this.cxOneAgent){
            mapCount += this.categoryMap[this.cxOneAgent.lastName.slice(0, 1).toUpperCase()];
        }

        switch (mapCount) {
            case 1:
            case 7:
                color = '#6443e5';
                break;
            case 2:
            case 8:
                color = '#abb9cb';
                break;
            case 3:
            case 9:
                color = '#f44336';
                break;
            case 4:
            case 10:
                color = '#2AA198';
                break;
            case 5:
            case 11:
                color = '#43A047';
                break;
            case 6:
            case 12:
                color = '#B58900';
                break;
            default:
                color = '#039be5';
        }

        return color;
    }
}
